import {
	Button,
	FormControlLabel,
	FormLabel,
	Input,
	Switch,
} from "@mui/material";
import { developAxios } from "../../axios.config";
import { Store } from "react-notifications-component";
import { useMutation } from "react-query";
import axios from "axios";
import { useState, useRef, FormEvent } from "react";

interface ICloneDashboard {
	_id: string;
	name: string;
}

function CloneDashboard({
	_id: dashboardId,
	name: dashboardName,
}: ICloneDashboard) {
	const [logoUrl, setLogoUrl] = useState<string>("");
	const [name, setName] = useState<string>("");
	const [cloneAptitude, setCloneAptitude] = useState(false);
	const [cloneTechnicalMcq, setCloneTechnicalMcq] = useState(false);
	const [cloneCoding, setCloneCoding] = useState(false);
	const [cloneHybrid, setCloneHybrid] = useState(false);

	const collegeLogoRef = useRef<HTMLInputElement>(null);

	const { mutateAsync: uploadImage } = useMutation(async () => {
		if (!collegeLogoRef.current) return;
		const logo =
			collegeLogoRef.current.files && collegeLogoRef.current.files[0];
		if (!logo) return;

		const name_arr = logo.name.split(".");
		const type = name_arr[name_arr.length - 1];

		const { data } = await developAxios(
			localStorage.getItem("token") || ""
		).get<{
			data: { presignedUrl: string; url: string };
		}>("/superadmin/course/college-logo-presigned-url", {
			params: {
				fileType: type || "png",
			},
		});
		setLogoUrl(data.data.url);
		await axios.put(data.data.presignedUrl, logo);

		return data.data.url;
	});

	const { mutateAsync: handleSubmit } = useMutation(
		(e: FormEvent<HTMLFormElement>) => {
			e.preventDefault();
			return developAxios(localStorage.getItem("token") || "").post(
				"/superadmin/course/clone-dashboard",
				{
					name,
					collegeLogo: logoUrl,
					dashboardId,
				},
				{
					params: {
						aptitude: cloneAptitude,
						technical_mcq: cloneTechnicalMcq,
						coding: cloneCoding,
						hybrid: cloneHybrid,
					},
				}
			);
		},
		{
			onError: (error: any) => {
				if (error.name === "AxiosError") {
					const error_message = error.response.data.message;
					notifyPopup(error_message, "danger");
				}
			},
			onSuccess: () => {
				notifyPopup("Dashboard created successfully", "success");
				setLogoUrl("");
				setName("");
			},
		}
	);

	function notifyPopup(backend_message: string, type: "success" | "danger") {
		Store.addNotification({
			title: type === "danger" ? "Error Occured" : "Success",
			message: backend_message,
			type: type,
			insert: "bottom",
			container: "bottom-right",
			animationIn: ["animate__animated", "animate__fadeIn"],
			animationOut: ["animate__animated", "animate__fadeOut"],
			dismiss: {
				duration: 3000,
				onScreen: true,
			},
		});
	}

	return (
		<form onSubmit={handleSubmit} className="space-y-4">
			<div>
				Cloning <span className="font-semibold">{dashboardName}</span>{" "}
				Dashboard
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="name">New Dashboard Name</FormLabel>
				<Input
					id="name"
					value={name}
					onChange={(e) => setName(e.target.value)}
					required
				/>
			</div>
			<div className="flex gap-4 items-center">
				<FormLabel htmlFor="college_logo">New Dashboard Logo</FormLabel>
				<input
					id="college_logo"
					type="file"
					ref={collegeLogoRef}
					onChange={(e) => uploadImage()}
					required
					accept="image/*"
				/>
			</div>

			<div className="flex flex-col">
				<FormControlLabel
					required
					control={
						<Switch
							value={cloneAptitude}
							onChange={(e) => setCloneAptitude(e.target.checked)}
						/>
					}
					label="Clone Aptitude"
				/>
				<FormControlLabel
					required
					control={
						<Switch
							value={cloneTechnicalMcq}
							onChange={(e) =>
								setCloneTechnicalMcq(e.target.checked)
							}
						/>
					}
					label="Clone Technical MCQs"
				/>
				<FormControlLabel
					required
					control={
						<Switch
							value={cloneCoding}
							onChange={(e) => setCloneCoding(e.target.checked)}
						/>
					}
					label="Clone Coding Questions"
				/>
				<FormControlLabel
					required
					control={
						<Switch
							value={cloneHybrid}
							onChange={(e) => setCloneHybrid(e.target.checked)}
						/>
					}
					label="Clone Hybrid Exams"
				/>
			</div>
			<Button variant="contained" type="submit">
				Clone Dashboard
			</Button>
		</form>
	);
}

export default CloneDashboard;
